
import React from 'react';
import { Phone } from 'lucide-react';

const ChurchSteepleHero = () => {
  return (
    <div className="relative bg-gradient-to-r from-brand-charcoal-gray to-brand-charcoal-gray/90 text-white py-20">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-4">Expert Church Steeple Repair & Restoration Services in Eastern NC</h2>
        <p className="text-xl italic mb-6">Preserving sacred architecture with trophy-quality craftsmanship | Serving congregations throughout Wilson, Greenville, Raleigh, Durham and all of Eastern North Carolina</p>
        
        <div className="bg-brand-safety-orange text-white p-4 rounded-md mb-8 flex flex-col md:flex-row items-center justify-between">
          <div className="flex items-center mb-4 md:mb-0">
            <Phone className="w-6 h-6 mr-2" />
            <strong className="text-lg">24/7 Emergency Steeple Stabilization: (252) 371-2266</strong>
          </div>
          <span className="bg-white/20 px-4 py-1 rounded-full text-sm">4-Hour Response for Storm Damage</span>
        </div>
      </div>
    </div>
  );
};

export default ChurchSteepleHero;
